var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "document-item" }, [
    _c("div", { staticClass: "document-item__data" }, [
      _c("div", { staticClass: "document-item__name" }, [
        _vm._v(_vm._s(_vm.document.name)),
      ]),
      _vm.hasColorMarks
        ? _c(
            "div",
            { staticClass: "document-item__colors" },
            [
              _vm.document.absent_color
                ? _c("document-issue-mark", {
                    staticClass: "document-item__color",
                    attrs: {
                      issue: "absent",
                      color: _vm.document.absent_color,
                    },
                  })
                : _vm._e(),
              _vm.document.expired_color
                ? _c("document-issue-mark", {
                    staticClass: "document-item__color",
                    attrs: {
                      issue: "expired",
                      color: _vm.document.expired_color,
                    },
                  })
                : _vm._e(),
              _vm.document.expiring_color
                ? _c("document-issue-mark", {
                    staticClass: "document-item__color",
                    attrs: {
                      issue: "expiring",
                      color: _vm.document.expiring_color,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.criticalityLabel
        ? _c("div", { staticClass: "document-item__criticality" }, [
            _c("span", [_vm._v(_vm._s(_vm.criticalityLabel))]),
            _c(
              "svg",
              {
                attrs: {
                  width: "6",
                  height: "6",
                  viewBox: "0 0 6 6",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M5.733 3.045L3.9 3.344L5.213 4.67L3.783 5.71L2.925 4.059L2.067 5.723L0.637 4.683L1.937 3.357L0.104 3.045L0.637 1.407L2.301 2.213L2.041 0.353999H3.809L3.536 2.226L5.187 1.394L5.733 3.045Z",
                    fill: "#FF238D",
                  },
                }),
              ]
            ),
          ])
        : _vm._e(),
    ]),
    _c(
      "div",
      { staticClass: "document-item__actions" },
      [
        _c("c-button-2", {
          staticClass: "document-item__edit",
          attrs: { size: "iconic", icon: "edit" },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "edit-document",
                params: { id: _vm.document.id },
              })
            },
          },
        }),
        _c("c-button-2", {
          directives: [
            {
              name: "b-popover",
              rawName: "v-b-popover.html",
              value: {
                container: "#app",
                trigger: "hover blur",
                boundary: "window",
                content: _vm.document.is_archive
                  ? "Восстановить"
                  : "Добавить в архив",
                placement: "top",
              },
              expression:
                "{\n        container: '#app',\n        trigger: 'hover blur',\n        boundary: 'window',\n        content: document.is_archive ? 'Восстановить' : 'Добавить в архив',\n        placement: 'top',\n      }",
              modifiers: { html: true },
            },
          ],
          staticClass: "documents-group__edit",
          attrs: { size: "iconic", icon: "box-arhive" },
          on: { click: _vm.onArchive },
        }),
        _c(
          "span",
          { attrs: { id: `document-remove-wrapper-${_vm.document.id}` } },
          [
            _c("c-button-2", {
              directives: [
                {
                  name: "b-popover",
                  rawName: "v-b-popover.html",
                  value: {
                    container: "#app",
                    trigger: "hover blur",
                    boundary: "window",
                    content: "Удалить",
                    placement: "top",
                  },
                  expression:
                    "{\n          container: '#app',\n          trigger: 'hover blur',\n          boundary: 'window',\n          content: 'Удалить',\n          placement: 'top',\n        }",
                  modifiers: { html: true },
                },
              ],
              staticClass: "document-item__remove",
              attrs: {
                size: "iconic",
                icon: { icon: "trash", color: "secondary" },
                disabled: !_vm.document.canDelete,
              },
              on: { click: _vm.onRemove },
            }),
          ],
          1
        ),
        !_vm.document.canDelete
          ? _c(
              "b-popover",
              {
                attrs: {
                  placement: "top",
                  triggers: "hover blur",
                  target: `document-remove-wrapper-${_vm.document.id}`,
                },
              },
              [
                _c("error-feedback", {
                  staticClass: "m-0 empty-category-tooltip",
                  attrs: {
                    text: "В данный момент удаление невозможно, так как документ добавлен для сотрудников.",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _c("c-button-2", {
          staticClass: "document-item__move",
          attrs: { size: "iconic", icon: "arrows-constructor" },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }